import { en, type TranslationKey } from "./en";

const ru: Record<TranslationKey, string> = {
  ...en,
  "portfolio.brokerSync.title": "Синхронизация с брокерами",
  "portfolio.brokerSync.description": "Автоматическая загрузка операций с привязанных брокерских счетов.",
  "portfolio.brokerSync.enabled": "Синхронизация включена",
  "portfolio.brokerSync.disabled": "Синхронизация выключена",
  "portfolio.brokerSync.emptyAccounts": "Нет счетов с загрузкой",
  "portfolio.brokerSync.managementIntro": "Введите код управления, чтобы менять настройки брокеров или проверять подключение. Состояние счетов и открытые проблемы доступны без кода.",
  "portfolio.brokerSync.managementCode": "Код управления",
  "portfolio.brokerSync.unlock": "Открыть настройки",
  "portfolio.brokerSync.lock": "Закрыть настройки",
  "portfolio.brokerSync.unlockError": "Код неверен или настройки брокеров недоступны.",
  "portfolio.brokerSync.settingsError": "Не удалось загрузить настройки брокеров.",
  "portfolio.brokerSync.save": "Сохранить настройки",
  "portfolio.brokerSync.saving": "Сохранение…",
  "portfolio.brokerSync.saved": "Настройки брокеров сохранены.",
  "portfolio.brokerSync.overlapDays": "Повторно проверять предыдущие дни при каждом запуске",
  "portfolio.brokerSync.deepWindowDays": "Глубина еженедельной перепроверки истории (дней)",
  "portfolio.brokerSync.invalidNumber": "Введите целое число в допустимом диапазоне.",
  "portfolio.brokerSync.secretSaved": "Секрет задан",
  "portfolio.brokerSync.secretMissing": "Секрет не задан",
  "portfolio.brokerSync.secretInputHint": "Оставьте поле пустым, чтобы сохранить текущее значение. Сохранённые секреты нельзя просмотреть.",
  "portfolio.brokerSync.replaceSecret": "Введите новый секрет для замены",
  "portfolio.brokerSync.queryId": "Идентификатор Activity Flex Query",
  "portfolio.brokerSync.ibkrToken": "Токен Flex Web Service",
  "portfolio.brokerSync.tbankToken": "Токен только для чтения",
  "portfolio.brokerSync.finamSecret": "Секрет Finam Trade API",
  "portfolio.brokerSync.instructions": "Как настроить",
  "portfolio.brokerSync.ibkrInstructions": "В Performance & Reports → Flex Queries создайте Activity Flex Query. Включите три раздела: Trades, Cash Transactions и Corporate Actions. Формат — XML. Уровень детализации (Level of Detail): в Trades — Execution, в Cash Transactions и Corporate Actions — Detail. Загрузка читает именно эти строки; агрегаты (Order, Symbol Summary, Summary) ей не нужны, а если они есть в выписке, пропускаются. В каждом разделе отметьте все поля (Select All) — без них операции не распознаются, а поле Level of Detail нужно, чтобы отличить подробные строки от агрегатов. Загрузка читает поля (имена XML-атрибутов; в Flex Query им соответствуют одноимённые поля, например Account ID — accountId). Trades: accountId, accountAlias, currency, assetCategory, assetClass, subCategory, symbol, description, listingExchange, exchange, securityId, securityIdType, isin, cusip, tradeId, tradeDate, tradeTime, dateTime, transactionType, quantity, tradePrice, price, ibCommission, ibCommissionCurrency, buySell, proceeds, tradeMoney, multiplier, levelOfDetail. Cash Transactions: accountId, accountAlias, currency, assetCategory, assetClass, subCategory, symbol, description, listingExchange, exchange, securityId, securityIdType, isin, cusip, dateTime, amount, type, tradeId, code, levelOfDetail. Corporate Actions: accountId, accountAlias, currency, assetCategory, assetClass, subCategory, symbol, description, listingExchange, securityId, securityIdType, isin, cusip, dateTime, reportDate, amount, proceeds, value, quantity, code, type, transactionId, actionId, actionDescription, ratio, splitRatio, levelOfDetail. Сохраните Query ID. В Flex Web Service Configuration включите сервис и создайте токен с самым длинным из доступных сроков действия: по умолчанию токен действует 6 часов, поэтому его придётся продлевать.",
  "portfolio.brokerSync.tbankInstructions": "Создайте токен только для чтения в Т-Инвестициях. Для счетов «Инвесткопилка», «Счёт под ключ» и «Смарт-счёт» нельзя выпустить токен на один конкретный счёт. Токен действует 3 месяца с последнего использования.",
  "portfolio.brokerSync.finamInstructions": "Создайте secret в разделе «Токены» портала Finam Trade API.",
  "portfolio.brokerSync.accountIdHint": "После проверки подключения выберите номер брокерского счёта из результата и укажите его при привязке счёта приложения.",
  "portfolio.brokerSync.checkConnection": "Проверить подключение",
  "portfolio.brokerSync.checkingConnection": "Проверка…",
  "portfolio.brokerSync.connectionFailed": "Не удалось проверить подключение",
  "portfolio.brokerSync.connectionHttpError": "Проверка подключения не пройдена: {reason}",
  "portfolio.brokerSync.invalidManagementCode": "Код управления не принят. Введите его ещё раз и повторите действие.",
  "portfolio.brokerSync.managementUnavailable": "Настройки подключения к брокерам не настроены на сервере.",
  "portfolio.brokerSync.brokerAccounts": "Счета у брокера",
  "portfolio.brokerSync.noBrokerAccounts": "Брокер не вернул список счетов.",
  "portfolio.brokerSync.historyAvailable": "История операций доступна (проверено записей: {count}).",
  "portfolio.brokerSync.historyUnavailable": "Не удалось проверить историю операций: {reason}",
  "portfolio.brokerSync.connectionNeedsAccounts": "Список счетов получен, но историю операций проверить не удалось: {reason}",
  "portfolio.brokerSync.accountsChecked": "Проверено счетов: {count}.",
  "portfolio.brokerSync.historyAccount": "История проверена по брокерскому счёту {accountId}.",
  "portfolio.brokerSync.connectionPartial": "Проверка истории завершена: проверено счетов — {checked}, с ошибкой — {failed}, получено записей — {count}.",
  "portfolio.brokerSync.setupInstructions": "Инструкция по подключению брокеров",
  "portfolio.brokerSync.runResults": "Итоги загрузки",
  "portfolio.brokerSync.counterImported": "Загружено",
  "portfolio.brokerSync.counterCreated": "Создано",
  "portfolio.brokerSync.counterUpdated": "Обновлено",
  "portfolio.brokerSync.counterAppliedSplits": "Сплитов применено",
  "portfolio.brokerSync.counterDisappeared": "Не найдены в последнем ответе",
  "portfolio.brokerSync.counterPairedTransfer": "Переводов сопоставлено",
  "portfolio.brokerSync.counterDeferredTransfer": "Переводов ожидают пару",
  "portfolio.brokerSync.counterStandaloneTransfer": "Переводов без пары",
  "portfolio.brokerSync.counterOutOfScope": "Вне поддержки",
  "portfolio.brokerSync.counterUnsupported": "Неподдерживаемые операции",
  "portfolio.brokerSync.counterInvalidPayload": "Некорректные записи",
  "portfolio.brokerSync.counterUnmatchedInstrument": "Инструменты не сопоставлены",
  "portfolio.brokerSync.counterInstrumentCandidate": "Нужно проверить инструмент",
  "portfolio.brokerSync.counterCurrencyUnresolved": "Валюты не распознаны",
  "portfolio.brokerSync.counterCorporateAction": "Корпоративные действия на проверку",
  "portfolio.brokerSync.counterSuppressedCommission": "Дубли комиссий пропущены",
  "portfolio.brokerSync.counterBeforeCutoff": "До даты начала загрузки",
  "portfolio.brokerSync.counterHelpTitle": "Что означают эти итоги?",
  "portfolio.brokerSync.counterHelp": "Загружено — число строк портфолио, созданных или обновлённых по данным брокера. Сопоставленные переводы найдены на обоих привязанных счетах; переводы без пары ждут вторую часть. Операции вне поддержки намеренно пропущены. Открытые проблемы требуют проверки перед загрузкой.",
  "portfolio.brokerSync.noRunCounters": "Для этого запуска нет ненулевых счётчиков.",
  "portfolio.brokerSync.accountStatus": "Привязанные счета",
  "portfolio.brokerSync.accountName": "Счёт приложения",
  "portfolio.brokerSync.brokerAccountId": "Номер счёта у брокера",
  "portfolio.brokerSync.fromDate": "Загрузка с",
  "portfolio.brokerSync.lastRun": "Последний запуск",
  "portfolio.brokerSync.neverRun": "Ещё не запускалась",
  "portfolio.brokerSync.openIssues": "Открытые проблемы",
  "portfolio.brokerSync.intentionallySkipped": "Намеренно пропущено",
  "portfolio.brokerSync.pendingTransfers": "Переводы без найденной пары",
  "portfolio.brokerSync.runError": "Ошибка запуска",
  "portfolio.brokerSync.issueList": "Открытые проблемы загрузки",
  "portfolio.brokerSync.noIssues": "Открытых проблем нет.",
  "portfolio.brokerSync.issuesLoading": "Загрузка проблем…",
  "portfolio.brokerSync.issuesError": "Не удалось загрузить проблемы.",
  "portfolio.brokerSync.issuesTruncated": "Показаны последние {shown} из {total} проблем.",
  "portfolio.brokerSync.issueDetails": "Данные операции",
  "portfolio.brokerSync.operationKey": "Ключ операции",
  "portfolio.brokerSync.issueDetected": "Последнее обнаружение",
  "portfolio.brokerSync.statusError": "Не удалось загрузить состояние синхронизации.",
  "portfolio.brokerSync.statusLoading": "Загрузка состояния синхронизации…",
  "portfolio.brokerSync.errorGeneric": "Ошибка запроса: {reason}",
  "portfolio.brokerSync.errorUnknown": "Не удалось выполнить запрос.",
  "portfolio.brokerSync.errorValidation": "Проверка параметров не пройдена: {reason}",
  "portfolio.brokerSync.settingsInvalid": "Файл настроек повреждён: {reason}. Задайте параметры ниже и сохраните — файл будет перезаписан. Пустые поля секретов сохраняют прежние значения, если они читаются.",
  "portfolio.brokerSync.settingsFileInvalidStatus": "Файл настроек повреждён: синхронизация не запускается, пока его не исправят.",
  "portfolio.brokerSync.secretUnknown": "Состояние секрета неизвестно",
  "portfolio.brokerSync.numbersInvalidBlocked": "Исправьте выделенные значения: настройки не сохранены.",
  "portfolio.brokerSync.saveTokenFirst": "Сначала сохраните токен: проверка подключения использует только сохранённые секреты.",
  "portfolio.brokerSync.checkWindow": "Проверено окно: {from} – {to}.",
  "portfolio.brokerSync.checkedAccountList": "Проверены счета: {accounts}.",
  "portfolio.brokerSync.failedAccountList": "Счета с ошибкой: {accounts}.",
  "portfolio.brokerSync.failedAccountItem": "{accountId}: {reason}",
  "portfolio.brokerSync.reasonAccountsUnavailable": "История операций не проверялась: список счетов недоступен.",
  "portfolio.brokerSync.reasonNoAccounts": "История операций не проверялась: брокер не вернул счетов.",
  "portfolio.brokerSync.reasonSecretNotConfigured": "Токен или секрет не заданы: сохраните их в настройках выше.",
  "portfolio.brokerSync.reasonInvalidCredentials": "Токен или секрет недействителен либо истёк: выпустите новый и сохраните его.",
  "portfolio.brokerSync.reasonAccessDenied": "Токен не даёт нужного доступа: проверьте его тип и права.",
  "portfolio.brokerSync.reasonRateLimited": "Брокер ограничил число запросов: повторите проверку позже.",
  "portfolio.brokerSync.reasonBrokerUnavailable": "Сервис брокера временно недоступен: повторите проверку позже.",
  "portfolio.brokerSync.reasonNetwork": "Не удалось связаться с брокером: проверьте сеть и повторите.",
  "portfolio.brokerSync.reasonStatementSections": "В выписке Interactive Brokers нет нужных разделов или полей: проверьте Activity Flex Query по инструкции выше.",
  "portfolio.brokerSync.brokerErrorWithDetail": "{reason} Ответ брокера: {detail}",
  "portfolio.brokerSync.brokerErrorUnknown": "Ошибка брокера: {detail}",
  "portfolio.brokerSync.counterDividendsUnconfirmedBasis": "Дивиденды с неподтверждённой базой (брутто или нетто)",
  "portfolio.brokerSync.counterSymbolsCreated": "Создано инструментов",
  "portfolio.brokerSync.counterProviderIssues": "Записей брокера с проблемами",
  "portfolio.brokerSync.counterRetryOperations": "Операций повторно обработано",
  "portfolio.brokerSync.counterFinamTradeBlocks": "Finam: операций с блоком сделки пропущено",
  "portfolio.brokerSync.counterIbkrAggregateSkipped": "IBKR: итоговых строк пропущено (загружаются детальные)",
  "portfolio.brokerSync.counterIbkrAggregateFallback": "IBKR: разделов только с итоговыми строками (загружены как есть)",
  "portfolio.brokerSync.linkTitle": "Привязка к брокеру",
  "portfolio.brokerSync.linkProvider": "Брокер для загрузки",
  "portfolio.brokerSync.linkProviderDisabled": "Загрузка выключена",
  "portfolio.brokerSync.linkFrom": "Загружать операции с",
  "portfolio.brokerSync.linkRequired": "Укажите номер счёта у брокера и дату начала загрузки.",
  "portfolio.brokerSync.linkFailed": "Не удалось обновить привязку к брокеру.",
  "portfolio.brokerSync.cancel": "Отмена",
  "portfolio.brokerSync.saveLink": "Сохранить",
};

const translations: Record<string, Record<TranslationKey, string>> = {
  en,
  ru,
  "ru-RU": ru,
};

const browserLocale = typeof navigator === "undefined" ? "en" : navigator.language;
let currentLocale = browserLocale.toLowerCase().startsWith("ru") ? "ru-RU" : "en";

export function setLocale(locale: string) {
  if (translations[locale]) currentLocale = locale;
}

export function getLocale(): string {
  return currentLocale;
}

/** Translate with an explicit locale, independent of the browser-derived current locale. */
export function translate(
  locale: string,
  key: TranslationKey,
  params?: Record<string, string | number>,
): string {
  const dict = translations[locale] ?? en;
  let str: string = dict[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      str = str.replace(`{${k}}`, () => String(v));
    }
  }
  return str;
}

export function t(
  key: TranslationKey,
  params?: Record<string, string | number>,
): string {
  const dict = translations[currentLocale] ?? en;
  let str: string = dict[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      str = str.replace(`{${k}}`, () => String(v));
    }
  }
  return str;
}
